(ns guidebook.views.cover-page
  (:import
   [goog.date DateTime])
  (:require
   [reagent.core :as r]
   [branding.views :as branding]
   [guidebook.common :refer [title-s body-s]]
   [very.re-frame.core :as rf]
   [cljss.core :as cljss]
   [css.core
    :refer [get-theme]
    :refer-macros [defstyled]]))

(defstyled name-s :h2
  {:color "white"
   :font-size "40px"
   :margin-bottom "92px"
   ::cljss/media {[:print]
                  {:font-size "24px"
                   :-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :margin-bottom "60px"}}})

(defstyled date-s :span
  {:font-size "40px"
   :font-weight 300
   ::cljss/media {[:print]
                  {:font-size "24px"}}})

(defstyled cover-content-s :div
  {:padding "82px 100px"})

(defstyled cover-logo-s :div
  {:margin-bottom "3rem"})

(defstyled cover-body-s :div
  {:max-width "540px"})

(defstyled label-s :div
  {:font-size "28px"
   :color "white"
   :font-weight "300"
   :line-height "32px"
   :margin-bottom "40px"
   :margin-top "50px"
   ::cljss/media {[:print]
                  {:font-size "20px"
                   :margin-bottom "5px"}}})

(defn content [{:keys [advisor client]}]
  [cover-content-s {:style {:color "white"}}
   [cover-logo-s
    [branding/logo]]
   [title-s {:color "white"
             :data-test "gameplan-page"} "PERSONALIZED GAME PLAN"]
   [cover-body-s
    [body-s {:color "white"} "We've created a plan together and we've put this document together to assure we both know what to expect. Our goal is to be transparent and clear."]
    [body-s {:color "white"
             :data-test "guidebook-advisor-name"} (str "Reach out to " (:name advisor) " any time at")]
    [body-s {:color "white"} (str (:phone advisor) " with questions.")]]
   [label-s "Prepared for the"]
   [name-s {:data-test "guidebook-household-name"} (str (:name client) " household")]
   [date-s (util.core/to-utc-time (.toString (DateTime.)) "MMM YYYY")]])

(defstyled cover-page-s :div
  {:display "grid"
   :grid-template-columns "7fr 3fr"
   :min-height "100vh"})

(defstyled cover-block-s :div
  {:background-color "black"
   :height "100%"
   ::cljss/media {[:print]
                  {:position "absolute"
                   :left "0"
                   :width "55%"
                   :top "0"
                   :bottom "0"}}})

(defstyled cover-image-s :div
  {:height "calc(100% - 100px)"
   :top "50px"
   :right "50px"
   :bottom "50px"
   :width "calc(30% - 50px)"
   :position "absolute"
   :background-image "url(/assets/bridge.jpg)"
   :background-position "center"
   :background-size "cover"
   :background-repeat "no-repeat"
   ::cljss/media {[:print]
                  {:width "calc(45% - 50px)"
                   :left "55%"}}})

(defn main []
  (let [cover-page (rf/subscribe [:guidebook/cover-page])]
    (fn []
      [cover-page-s
       [cover-block-s
        [content @cover-page]]
       [cover-image-s]])))
